import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../../contexts/DataContext";
import Panel from "../UI/Panel/Panel";
import PanelContent from "../UI/Panel/PanelContent";
import PanelTitle from "../UI/Panel/PanelTitle";
import styled from "styled-components";
import StadiumEditor from "../Modals/StadiumEditor";
import { Button } from "../../Theme/Hyper";

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  > tbody > tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }

  th {
    padding: 10px;
    border-top: 1px solid #dee2e6;
  }
  td {
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    width: ${(props) => props.width};
    padding: 8px;
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.8em;
  }
  > tbody > tr:hover {
    background-color: #14ec8e;
    color: white;
    cursor: pointer;
  }
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #343a40;
  text-align: left;
`;
export default function StadiumsList() {
  const { getStadium } = useContext(DataContext);
  const [stadiums, setStadiums] = useState();
  const [selectedStadium, setSelectedStadium] = useState();

  useEffect(() => {
    getData();
  }, []);

  function getData() {
    getStadium().then((data) => {
      setStadiums(
        [...data].sort((a, b) => {
          if (a.opta_name < b.opta_name) {
            return -1;
          }
          if (a.opta_name > b.opta_name) {
            return 1;
          }
          return 0;
        })
      );
    });
  }
  return (
    <>
      <Button
        green
        style={{ margin: "1em", width: "200px" }}
        onClick={() => {
          setSelectedStadium({});
        }}
      >
        + Create Stadium
      </Button>
      <Panel style={{ marginTop: "1em" }}>
        <PanelTitle title={"Stadium List"} />
        <PanelContent>
          <Table>
            <thead>
              <tr>
                <TH>ID</TH>
                <TH>OPTA ID</TH>
                <TH>OVAL ID</TH>
                <TH>Name</TH>
                <TH>Location</TH>
                {/* <TH>OPTA Name</TH> */}
              </tr>
            </thead>
            <tbody>
              {stadiums &&
                stadiums.map((stadium) => {
                  return (
                    <tr
                      onClick={() => {
                        setSelectedStadium(stadium);
                      }}
                    >
                      <td>{stadium._id}</td>
                      <td>{stadium.opta_ID}</td>
                      <td>{stadium.oval_ID}</td>
                      <td>{stadium.name || stadium.opta_name}</td>
                      <td>{stadium.location}</td>
                      {/* <td>{stadium.opta_name}</td> */}
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </PanelContent>
      </Panel>
      {selectedStadium && (
        <StadiumEditor
          stadium={selectedStadium}
          selectStadium={(s) => {
            setSelectedStadium(s);
          }}
          onCancel={() => {
            setSelectedStadium();
          }}
          onSave={() => {
            setSelectedStadium();
            getData();
          }}
        />
      )}
    </>
  );
}
